/**
 * Стек Dev48 в одном месте.
 *
 * Раньше список направлений жил только в TechnologiesClient, а страница
 * /technologies и ассистент говорили о технологиях каждый своим списком.
 * Теперь источник один: страница рисует его, а ассистент цитирует в ответах.
 */

interface LocalizedTitle {
  ru: string;
  en: string;
}

export interface StackCategory {
  /** Технический ключ группы — стабильный, не зависит от языка. */
  key: string;
  title: LocalizedTitle;
  items: string[];
}

/** Та же категория, но уже с готовым заголовком под язык страницы. */
export interface LocalizedStackCategory {
  key: string;
  title: string;
  items: string[];
}

export const STACK_CATEGORIES: StackCategory[] = [
  {
    key: "frontend",
    title: { ru: "Frontend", en: "Frontend" },
    items: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Framer Motion"],
  },
  {
    key: "backend",
    title: { ru: "Backend", en: "Backend" },
    items: ["Python", "Go", "Java", "Node.js", "FastAPI", "Django"],
  },
  {
    key: "databases",
    title: { ru: "Базы данных", en: "Databases" },
    items: ["PostgreSQL", "MongoDB", "Redis", "Elasticsearch"],
  },
  {
    key: "mobile",
    title: { ru: "Mobile", en: "Mobile" },
    items: ["React Native", "Swift", "Kotlin", "Flutter"],
  },
  {
    key: "devops",
    title: { ru: "DevOps & Cloud", en: "DevOps & Cloud" },
    items: ["Docker", "Kubernetes", "AWS", "GCP", "CI/CD"],
  },
  {
    key: "ai",
    title: { ru: "AI & ML", en: "AI & ML" },
    items: ["TensorFlow", "PyTorch", "LangChain", "OpenAI API"],
  },
];

export function stackCategories(locale = "ru"): LocalizedStackCategory[] {
  const lang = locale.startsWith("ru") ? "ru" : "en";
  return STACK_CATEGORIES.map((category) => ({
    key: category.key,
    title: category.title[lang],
    items: category.items,
  }));
}

/** Плоский список всех технологий — единый источник правды о стеке. */
export const STACK_ITEMS: string[] = STACK_CATEGORIES.flatMap((category) => category.items);

/** Компактная строка стека для системного промпта ассистента. */
export function stackDigest(locale = "ru"): string {
  return stackCategories(locale)
    .map((category) => `${category.title}: ${category.items.join(", ")}`)
    .join("; ");
}
